import { handleError, type CustomError } from './error';

export function getItem({ key }: { key: string }) {
  try {
    const value = localStorage.getItem(key);
    if (value) {
      return JSON.parse(value);
    }
  } catch (err) {
    handleError(err as CustomError);
  }
  return undefined;
}

export function getItemWithExpiry({ key }: { key: string }) {
  try {
    const value = localStorage.getItem(key);
    if (!value) return null;
    const item = JSON.parse(value);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (item?.expiryTime && now.getTime() > item.expiryTime) {
      // If the item is expired, delete the item from storage
      // and return undefined
      localStorage.removeItem(key);
      return null;
    }
    return item;
  } catch (err) {
    handleError(err as CustomError);
  }
  return null;
}

export function setItem({ key, value }: { key: string; value: unknown }) {
  try {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value));
      return;
    }
    localStorage.removeItem(key);
  } catch (err) {
    handleError(err as CustomError);
  }
}

export function setItemWithExpiry({
  key,
  value,
  expirySeconds,
}: {
  key: string;
  value: object;
  expirySeconds: number;
}) {
  try {
    const now = new Date();
    const expiryTime = now.getTime() + expirySeconds * 1000; // Convert seconds to milliseconds and add to current time

    setItem({
      key,
      value: {
        ...value,
        expiryTime,
        expirySeconds,
      },
    });
  } catch (err) {
    handleError(err as CustomError);
  }
}

export function removeItem({ key }: { key: string }) {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    handleError(err as CustomError);
  }
}
